import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Category } from 'src/models/DTO/V2/categories/Category';
import { CategoryAttribute } from 'src/models/DTO/attributes/attribute';
import { LocalstorageserviceService } from 'src/services/infrastructureServices/localstorageservice/localstorageservice.service';
import { CategoriesService } from 'src/services/requestServices/V2/categories/categories.service';
import { UserinfostoreService } from 'src/services/stateServices/userinfoservice/userregistrationstateservice.service';
import { Convertor } from 'src/infrastructure/convertorHelpers/convertor';
import {COMMA, ENTER, P} from '@angular/cdk/keycodes';
import { ProductsService } from 'src/services/requestServices/V2/products/products.service';
import { LoggeduserinfoService } from 'src/services/stateServices/loggeduserinfoservice/loggeduserinfo.service';
import { UsersService } from 'src/services/requestServices/users/users.service';
import { PartnersService } from 'src/services/requestServices/partners/partners.service';
import { environment } from 'src/environments/environment';
import { Product } from 'src/models/DTO/products/product';
import { ImagesService } from 'src/services/requestServices/images/images.service';
import { ItemService } from 'src/services/requestServices/item/item.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationHelper } from 'src/infrastructure/validationHelpers/validationHelper';
import { Successes } from 'src/config/labels/successes';
import { PackagingCorurierTypes } from 'src/config/labels/packagingCorurierTypes';
import { INFO_STATUSES } from 'src/config/labels/infoStatuses';
import { Conditions } from 'src/config/labels/conditions';
import { Genders } from 'src/config/labels/genders';
import { YesAndNo } from 'src/config/labels/yesNoOptions';
import { Colors } from 'src/config/labels/colors';
import { Sizes } from 'src/config/labels/sizes';
import { PackagingOptions } from 'src/config/labels/packagingOptions';
import { BrandsService } from 'src/services/requestServices/V2/brands/brands.service';
import { Brand } from 'src/models/DTO/V2/brands/Brand';
import { NewBrand } from 'src/models/DTO/V2/brands/NewBrand';
import { Base64Image } from 'src/models/DTO/V2/image/BaseEncodedImage';
import { TableVariation } from 'src/models/DTO/variations/tableVariation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ImageselectionComponent } from 'src/app/dialogs/ImageSelect/imageselection/imageselection.component';
import { VariationsService } from 'src/services/requestServices/variations/variations.service';
import { PricingService } from 'src/services/requestServices/pricing/pricing.service';
import { ImageuploadComponent } from 'src/app/shared/images/imageupload.component';
import { StorestabsComponent } from 'src/app/shared/storestabs/storestabs.component';
import { debounceTime, pairwise, startWith, tap, distinctUntilChanged, map, finalize } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { Errors } from 'src/config/labels/errors';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseItemComponent } from '../base-item/base-item.component';
import { LocationsService } from 'src/services/requestServices/locations/locations.service';
import { Store } from 'src/models/DTO/stores/store';
import { Variation } from 'src/models/DTO/variations/variation';
import { InfoService } from 'src/services/requestServices/V2/info/info.service';
import { LoggedinfoService } from 'src/services/stateServices/V2/loggedinfo/loggedinfo.service';
import { CreateNewBrandRequestModel } from 'src/models/requestModels/V2/brand/CreateNewBrandRequestModel';
import { CreateNewProductRequestModel } from 'src/models/requestModels/V2/product/CreateNewProductRequestModel';
import { ManifacturerService } from 'src/services/requestServices/V2/manifacturers/manifacturer.service';
import { CreateNewManufacturerRequestModel } from 'src/models/requestModels/V2/manufacturer/CreateNewManufacturerRequestModel';
import { Product as CreatedProduct } from 'src/models/DTO/V2/product/Product';
import { OptionService } from 'src/services/requestServices/V2/options/option.service';
import { Option } from 'src/models/DTO/V2/options/Option';
import { ImageCollection } from 'src/models/DTO/V2/image/ImageCollection';
import { ProductoptionService } from 'src/services/requestServices/V2/productOption/productoption.service';
import { AttachOptionRequestModel } from 'src/models/requestModels/V2/option/AttachOptionRequestModel';
import { PricingService as PricingsService } from 'src/services/requestServices/V2/pricing/pricing.service';
import { CreateBasePricingRequestModel } from 'src/models/requestModels/V2/pricing/CreateBasePricingRequestModel';
import { CreatePricingRequestModel } from 'src/models/requestModels/V2/pricing/CreatePricingRequestModel';
import { TableBaseVariation } from 'src/models/DTO/V2/variation/TableBaseVariation';
import { SkuService } from 'src/services/requestServices/V2/sku/sku.service';
import { CreateSkuRequestModel } from 'src/models/requestModels/V2/sku/CreateSkuRequestModel';
import { SkuoptionService } from 'src/services/requestServices/V2/skuOption/skuoption.service';
import { AttachSkuOptionRequestModel } from 'src/models/requestModels/V2/option/AttachSkuOptionRequestModel';
import { VariationimagesComponent } from 'src/app/shared/variationimage/variationimages/variationimages.component';
import { PackagingService } from 'src/services/requestServices/V2/packaging/packaging.service';
import { CreatePackagingRequestModel } from 'src/models/requestModels/V2/packaging/CreatePackagingRequestModel';
import { Manufacturer } from 'src/models/DTO/V2/manufacturer/Manufacturer';
import { UpdateProductRequestModel } from 'src/models/requestModels/V2/product/UpdateProductRequestModel';
import { UpdateOptionRequestModel } from 'src/models/requestModels/V2/option/UpdateOptionRequestModel';
import { ProductOption } from 'src/models/DTO/V2/productOptions/ProductOption';
import { SkuCollection } from 'src/models/DTO/V2/sku/SkuCollection';
import { UpdateSkuOptionRequestModel } from 'src/models/requestModels/V2/option/UpdateSkuOptionRequestModel';
import { ProductPricing } from 'src/models/DTO/V2/pricing/ProductPricing';
import { ProductPackaging } from 'src/models/DTO/V2/packaging/ProductPackaging';
import { ImageService } from 'src/services/requestServices/V2/image/image.service';
import { TagsService } from 'src/services/requestServices/V2/tags/tags.service';
import { Tags } from 'src/models/DTO/V2/tag/Tags';
import { AttachDetachTagRequestModel } from 'src/models/requestModels/V2/tag/AttachDetachTagRequestModel';
import { CurrentProduct } from 'src/models/DTO/V2/product/CurrentProduct';
import { ValidationConfig } from 'src/infrastructure/validationHelpers/validationConfig';
import { CarrierService } from 'src/services/requestServices/V2/carrier/carrier.service';
import { DocumentsService } from 'src/services/requestServices/V2/documents/documents.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { CategoryPlain } from 'src/models/DTO/V2/categories/CategoryPlain';
import { LoadingstateService } from 'src/services/stateServices/loading/loadingstate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectorRef } from '@angular/core';


declare var bootstrap: any;

@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css']
})
export class AddproductComponent extends BaseItemComponent implements OnInit {
  @ViewChild(StorestabsComponent) set store(content: StorestabsComponent) {
    if (content) { // initially setter gets called with undefined
      this._storeTabsComponent = content;
      this._storeTabsComponent.setFormGroup(this.ship);
      this._storeTabsComponent.setProductId(this._createdProduct.id);
      this.getStores();
      this._imageUploadComponent.deleteImageCallback = (imageId) => {
        this.variationDataSource.data.forEach(element => {
          if (element.file.id === imageId) {
            element.file = null;
          }
        });
      };
    }
  }

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userStateService: UserinfostoreService,
    protected localStorageService: LocalstorageserviceService,
    protected loggeduserinfoservice: LoggeduserinfoService,
    protected router: Router,
    protected imagesService: ImagesService,
    protected sanitizer: DomSanitizer,
    protected usersService: UsersService,
    protected partnersService: PartnersService,
    protected locationService: LocationsService,
    protected loggedInfoService: LoggedinfoService,
    protected infoService: InfoService,
    private categoryService: CategoriesService,
    private productService: ProductsService,
    private itemService: ItemService,
    private toastrService: ToastrService,
    private brandsService: BrandsService,
    private variationService: VariationsService,
    private pricingService: PricingService,
    private dialogService: MatDialog,
    private fb: FormBuilder,
    private manufacturerService: ManifacturerService,
    private optionService: OptionService,
    private productOptionService: ProductoptionService,
    private skuOptionService: SkuoptionService,
    private pricingsService: PricingsService,
    private skuService: SkuService,
    private packagingService: PackagingService,
    protected imageService: ImageService,
    private tagsService: TagsService,
    protected carrierService: CarrierService,
    protected documentsService: DocumentsService,
    private loadingState: LoadingstateService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    super(activatedRoute, userStateService, localStorageService, usersService, loggeduserinfoservice,
      partnersService, imagesService, sanitizer, router, locationService, loggedInfoService,
      infoService, imageService, carrierService, documentsService);
    this.pageName = 'addProduct';
    this.loadData();
    this.loadCategories();
    this.completedTabs.info.completed = true;

    this.variationsDataSource = new MatTableDataSource(this.VARIATIONS_DATA);

    this.displayedColumnsForProductTable = ['image', 'size', 'color', 'sku', 'quantity', 'action'];
    this.variationDataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.createNewTableRow();

    this.productInfo = fb.group({
        category: ['', [Validators.required]],
        subcategory: ['', [Validators.required]],
        name: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.cyrylicFull)]],
        brand: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.cyrylicFull)]],
        manufacturer: ['', [Validators.pattern(ValidationConfig.regexes.cyrylicFull)]],
        condition: [this.condtions[0].value, [Validators.required]],
        quantity: [0, [Validators.required, Validators.pattern(ValidationConfig.regexes.numberOnly), Validators.min(0)]],
        barcode: ['', [Validators.required]],
        SKU: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.alpha_dash)]],
        VAT: [
          this.loggedPartner?.data?.organisations[0]?.vat_number ? '20' : '0',
          [Validators.required, Validators.pattern(ValidationConfig.regexes.numberOnly)]
        ],
        warranty: [0, [Validators.required, Validators.pattern(ValidationConfig.regexes.numberOnly)]],
        customBrand: ['', Validators.pattern(ValidationConfig.regexes.cyrylicFull)],
        subSubCategory: ['']
      });

    this.specs = fb.group({
        quantity: [''],
        gender: [this.genders[0].value],
        description: [''],
        // tags: ['']
    });

    this.pricing = fb.group({
        unitsFrom0: [{value: 1, disabled: true}, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        unitsFrom1: [{value: 2, disabled: true}, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        unitsFrom2: [{value: 3, disabled: true}, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        unitsFrom3: [{value: 4, disabled: true}, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        unitsFrom4: [{value: 5, disabled: true}, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        unitsTo4: [6, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        pricing0: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        pricing1: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        pricing2: ['',  [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        pricing3: ['',  [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        pricing4: ['',  [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
    });

    this.attachOnPriceEvent(this.pricing.controls.unitsFrom4, 4, this.onPriceFromAmountChange);
    this.attachOnPriceEvent(this.pricing.controls.unitsTo4, 4, this.onPriceToAmountChange);
    this.attachOnPriceEvent(this.pricing.controls.pricing0, 0, this.onPriceChange);
    this.attachOnPriceEvent(this.pricing.controls.pricing1, 1, this.onPriceChange);
    this.attachOnPriceEvent(this.pricing.controls.pricing2, 2, this.onPriceChange);
    this.attachOnPriceEvent(this.pricing.controls.pricing3, 3, this.onPriceChange);
    this.attachOnPriceEvent(this.pricing.controls.pricing4, 4, this.onPriceChange);


    this._priceRangeCount = environment.initialNumberOfPriceRanges;

    this.ship = fb.group({
        // packaging: [PackagingOptions.options[this._language][0].value, [Validators.required]],
        shippWithin: [null, [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]],
        height: [null, [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        length: [null, [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        depth: [null, [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        weight: [null, [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]],
        fragile: [false],
        test_before_pay: [false, [Validators.required]],
        check_before_pay: [false, [Validators.required]],
        courierType: [505, [Validators.required]]
      });

    this._tabidToFormgroup = {
        info: this.productInfo,
        specs: this.specs,
        price: this.pricing,
        inventory: null,
        ship: this.ship
      };

    this.loadingState.loading$.subscribe(result => {
        this.isLoading = result;
      });
  }

  get condtions(): { condition: string; value: string }[] {
    return Conditions.conditions[this._language];
  }

  get genders(): { gender: string; value: string }[] {
    return Genders.genders[this._language];
  }

  get yesAndNo(): Array<{option: string; value: boolean}> {
    return YesAndNo.options[this._language];
  }

  get packagingOptions(): string {
    return PackagingOptions.options[this._language];
  }

  get categories(): Array<any> {
    return this._categories?.data || [];
  }

  get subCategories(): Array<any> {
    return this._subCategories?.data || [];
  }

  get subSubCategories(): Array<any> {
    return this._subSubCategories || [];
  }

  get value(): number {
    return this.navValue;
  }


  get brands(): Array<any> {
    if (this._brands?.data.length && !this.productInfo.dirty && this._currentProduct?.data?.brand?.uuid) {
      this.productInfo.get('brand').setValue(this._currentProduct.data.brand.uuid);
    }
    return this._brands?.data || [];
  }

  get attributes(): CategoryAttribute[] {
    return this._categoryAttributes;
  }

  get options(): Array<any> {
    return this._options?.data || [];
  }

  get variations(): Array<any> {
    return this._variations?.data || [];
  }

  get priceRangeCount(): number {
    return this._priceRangeCount;
  }

  get customBrandId(): number {
    return this._customBrandId;
  }

  get defaultAttr(): string[] {
    return ['quantity', 'description', 'tags'];
  }

  get disabledAttr(): string[] {
    return ['color', 'size'];
  }

  get imagesPerProduct(): ImageCollection {
    return this._imagesPerProduct;
  }

  get userSelectedWhetherToShowVariations(): boolean {
    return this._userSelectedWhetherToShowVariations;
  }

  get colors(): { name: string; color: string }[] {
    return Colors;
  }

  get sizes(): { size: string; name: string }[] {
    return Sizes;
  }

  private set newCreatedProduct(createdProduct: CreatedProduct) {
    this._newCreatedProduct = createdProduct;
  }
  testExtrasValue = 'none';
  navValue =  33.2;
  filteredVariations = [];
  variationSlide = 'initial';
  readonly variationSlides = ['initial', 'variations'];
  productInfo: FormGroup;
  specs: FormGroup;
  pricing: FormGroup;
  ship: FormGroup;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  variationsDataSource: MatTableDataSource<TableBaseVariation>;
  displayedColumnsForVariations: string[] = ['image', 'sku', 'quantity', 'action'];
  completedTabs =  {
    info: {
      completed: false,
      tab: '#info',
      passed: false
    },
    specs: {
      completed: false,
      tab: '#specs',
      passed: false
    },
    variations: {
      completed: false,
      tab: '#variations',
      passed: false
    },
    price: {
      completed: false,
      tab: '#price',
      passed: false
    },
    delivery: {
      completed: false,
      tab: '#ship',
      passed: false

    },
  };
  public imageCollectionPerVariation: ImageCollection[] = [];
  public isTyresSub = false;
  public extrasLocked = false;

  btnPricesIsDisabled = false;
  tags: string[] = [];
  vcolors = [];
  vsizes = [];
  variationType: 'all' | 'size' | 'color' = 'all';
  private readonly LABELS = {
    color: 'Цвят',
    size: 'Размер',
  } as const;
  variationDataSource: MatTableDataSource<TableVariation>;
  displayedColumnsForProductTable: string[];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  public base64Files: Base64Image[] = [];
  private _detachInFlight = false;
  private _imagesPerProduct: ImageCollection;
  private _color = '';
  private _currentProduct: CurrentProduct;
  private _tags: Tags;
  private _productPricing: ProductPricing;
  private _productSkus: SkuCollection;
  private defaultColumnsForVariations: string[] = ['image', 'sku', 'quantity', 'action'];
  private _variationTypeInitialized = false;
  private VARIATIONS_DATA: TableBaseVariation[] = [];
  private _tabidToFormgroup: object;
  private _categories: Category;
  private _subCategories: Category;
  private _subSubCategories: CategoryPlain[] = [];
  private _brands: Brand;
  private _options: Option;
  private _productOptions: ProductOption;
  private _productPackaging: ProductPackaging;
  private _variations: Option;
  private _categoryAttributes: CategoryAttribute[] = [];
  private _priceRangeCount: number;
  private _errorMsgs = {
    info: '',
    specs: '',
    price: '',
    inventory: '',
    ship: ''
  };
  private _createdProduct: Product;
  private _newCreatedProduct: CreatedProduct;
  private _hasInstanceAttribute = false;
  private ELEMENT_DATA: TableVariation[] = [];
  private _customBrandId: number;
  private _userSelectedWhetherToShowVariations = false;
  private _optionUnits = new Map<string, string>();
  private _technicCategoryUUID = 'b51838c0-1561-417c-8b65-ce404618b625';
  private _savingOptionsInFlight = false;

  private readonly CT_STANDART_24 = 505;
  private readonly CT_PALLET      = 413;
  private readonly CT_TYRES       = 704;

  @ViewChild(ImageuploadComponent)
  private _imageUploadComponent: ImageuploadComponent;
  private _storeTabsComponent: StorestabsComponent;
  private labelFor = (k: 'size' | 'color') => (k === 'size' ? 'Размер' : 'Цвят');

  private async loadCategories(): Promise<void> {
    this.categoryService.getRootCategories().subscribe(
      (rootCategories) => {
        this._categories = rootCategories;
        if (this._newCreatedProduct?.data?.uuid) {
          this.loadCurrentProduct(this._newCreatedProduct.data.uuid).then(() => {
            this.categoryService.getParentCategory(this._currentProduct.data.category.uuid).subscribe(parentCategoryInfo => {
              const category = parentCategoryInfo.data[parentCategoryInfo.data.length - 1].uuid;
              this.productInfo.get('category').setValue(category);
              this.executePromisesOnCategoryChange(category).then(() => {
                  this.productInfo.get('subcategory').setValue(parentCategoryInfo.data[parentCategoryInfo.data.length - 2].uuid);
                  this._subSubCategories = this._subCategories.data.find(
                    subCategory => subCategory.uuid === parentCategoryInfo.data[parentCategoryInfo.data.length - 2].uuid
                  ).sub_categories;
                  this.productInfo.get('subSubCategory').setValue(parentCategoryInfo.data[parentCategoryInfo.data.length - 3]?.uuid || '');
                  if (parentCategoryInfo.data[parentCategoryInfo.data.length - 3]?.uuid) {
                    this.brandsService.getBrands(parentCategoryInfo.data[parentCategoryInfo.data.length - 3]?.uuid).subscribe(brands => {
                      this._brands = brands;
                    });
                  }
                  else {
                    this.productInfo.get('brand').setValue(this._currentProduct.data.brand.uuid);
                  }
              });
            });
          });
        }
        // else {
        //   const category = this.categories[0].uuid;
        //   //this.productInfo.get('category').setValue(category);
        //   //this.executePromisesOnCategoryChange(category);
        // }
    });
  }

  private createBrand(): Promise<NewBrand> {
    const newBrand: CreateNewBrandRequestModel = {
      category_uuid: this.productInfo.get('subcategory').value,
      name: this.productInfo.get('customBrand').value,
    };
    return this.brandsService.createNewBrand(newBrand).toPromise();
  }

  private loadFullOptions(subCategoryUUID: string): void {
    this.optionService.getOptionsForSubCategory(subCategoryUUID, false).subscribe(options => {
      this._options = options;
      this.addAttributesFormControl();
      if (this._newCreatedProduct?.data?.uuid) {
        this.getProductOptions();
      }
    });

    this.optionService.getOptionsForSubCategory(subCategoryUUID, true).subscribe(variations => {
      this._variations = variations;

      if (!this._variations?.data?.length) {
        this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();
        return;
      }

      this.vcolors = [];
      this.vsizes  = [];
      this._variations.data.forEach(v => {
        if (Array.isArray(v.values) && v.values.length) {
          v.values = v.values.slice().sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
        }
        if (v.field_name === 'color') { this.vcolors = v.values; }
        if (v.field_name === 'size')  { this.vsizes  = v.values; }
      });

      this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();

      if (this._newCreatedProduct?.data?.uuid) {
        this.prepareVariations();
      } else if (!this._variationTypeInitialized) {
        const hasSize  = (this.vsizes  || []).length > 0;
        const hasColor = (this.vcolors || []).length > 0;

        this.variationType =
          hasSize && hasColor ? 'all'
            : hasSize            ? 'size'
              : hasColor           ? 'color'
                : 'all';

        this.queueLoadVariations(this.variationType);
        this._variationTypeInitialized = true;
      }

      this.navValue = (this.variations.length) ? 28.4 : 33.2;
    });
  }



  private updateTags(): void {
    const arrayForDeletedTags: Promise<any>[] = [];
    const detachTagsModel: AttachDetachTagRequestModel = {
      subject_type: 'PRODUCT',
      subject_uuid: this._newCreatedProduct.data.uuid,
      tags: []
    };
    this._tags.data.forEach(tag => {
      detachTagsModel.tags.push(tag.slug);
    });
    if (detachTagsModel.tags.length) {
      this.tagsService.detachTags(detachTagsModel).subscribe(() => {
        this.createNewTags();
      });
    }
    else {
      this.createNewTags();
    }
  }

  private createNewTags(): void {
    if (!this.tags.length) {
      return;
    }
    const attachTagsModel: AttachDetachTagRequestModel = {
      subject_type: 'PRODUCT',
      subject_uuid: this._newCreatedProduct.data.uuid,
      tags: []
    };
    const tagsArray = this.tags;
    tagsArray.forEach(newTag => {
      attachTagsModel.tags.push(newTag);
    });
    this.tagsService.createTags(attachTagsModel).toPromise();
  }

  private requiredBoolean = (c: AbstractControl) => (
    c.value === true || c.value === false ? null : { required: true }
  )

  isRequired(ctrl: AbstractControl | null): boolean {
    if (!ctrl || !ctrl.validator) { return false; }
    const res = ctrl.validator({} as AbstractControl);
    return !!(res && 'required' in res);
  }

  private normalizeControlValue(opt: any, raw: any): { kind: 'empty' | 'boolean' | 'select' | 'number' | 'string'; value: any } {
    if (raw === null || raw === undefined) { return { kind: 'empty', value: null }; }
    if (typeof raw === 'string' && raw.trim() === '') { return { kind: 'empty', value: null }; }

    // BOOLEAN
    if (opt.type?.label === 'boolean') {
      const toBool = (v: any): boolean | null => {
        if (typeof v === 'boolean') { return v; }
        const s = String(v).trim().toLowerCase();
        if (['1', 'true', 'yes', 'да', 'y', 'on'].includes(s)) {  return true; }
        if (['0', 'false', 'no', 'не', 'n', 'off'].includes(s)) { return false; }
        return null;
      };
      const b = toBool(raw);
      return b === null ? { kind: 'empty', value: null } : { kind: 'boolean', value: b };
    }

    // SELECT (списъчни)
    const isSelect = !opt.can_accept_free_form_values || (opt.values?.length ?? 0) > 0;
    if (isSelect) {
      const pickedUuid =
        (typeof raw === 'object' && raw && 'uuid' in raw) ? String(raw.uuid)
          : (typeof raw === 'string' ? raw : String(raw ?? ''));
      const v = pickedUuid.trim();
      if (!v) { return { kind: 'empty', value: null }; }
      return { kind: 'select', value: v };
    }

    // FREE-FORM number
    if (opt.type?.label === 'number') {
      const n = typeof raw === 'number' ? raw : Number(String(raw).replace(',', '.'));
      if (!Number.isFinite(n)) { return { kind: 'empty', value: null }; }
      return { kind: 'number', value: n };
    }

    // FREE-FORM string
    return { kind: 'string', value: String(raw).trim() };
  }

  private async saveOptions(tab: any): Promise<void> {
    if (this._savingOptionsInFlight) { return; }
    this._savingOptionsInFlight = true;

    try {
      await this.updateCurrentProduct();
      this.updateTags();

      const productUuid = this._newCreatedProduct?.data?.uuid;
      if (!productUuid) { tab.show(); return; }

      try {
        this._productOptions = await this.productOptionService
          .getOptionsForProduct(productUuid)
          .toPromise();
      } catch {
        this._productOptions = { data: [] } as any;
      }

      const existingByOptionUuid = new Map<string, any>();
      (this._productOptions?.data ?? []).forEach((p: any) => {
        const k = String(p?.option?.uuid ?? p?.option_uuid ?? p?.uuid ?? '');
        if (k) { existingByOptionUuid.set(k, p); }
      });

      const uiOptionUuids = new Set(this.options.map(o => String(o.uuid)));
      const detaches: Promise<any>[] = [];
      existingByOptionUuid.forEach((_val, optUuid) => {
        if (!uiOptionUuids.has(optUuid)) {
          detaches.push(
            this.productOptionService
              .detachOptionToProduct({ product_uuid: productUuid, option_uuid: optUuid })
              .toPromise()
              .catch(() => {})
          );
        }
      });
      await Promise.all(detaches);

      for (const opt of this.options) {
        const ctrl = this.specs.get(opt.display_name.replace('.', ''));
        if (!ctrl) { continue; }

        const { kind, value } = this.normalizeControlValue(opt, ctrl.value);
        const isAttached = existingByOptionUuid.has(String(opt.uuid));

        if (kind === 'empty') {
          if (isAttached) {
            await this.productOptionService
              .detachOptionToProduct({ product_uuid: productUuid, option_uuid: opt.uuid })
              .toPromise()
              .catch(() => {});
          }
          continue;
        }

        const attachReq: AttachOptionRequestModel = {
          product_uuid: productUuid,
          option_uuid: opt.uuid,
          value
        };
        const updateReq: UpdateOptionRequestModel = {
          product_uuid: productUuid,
          option_uuid: opt.uuid,
          value
        };

        if (!isAttached) {
          await this.productOptionService
            .attachOptionToProduct(attachReq)
            .toPromise()
            .catch((err) => {
              const pg = err?.error?.exception?.code || err?.error?.code;
              if (pg !== '23505') { throw err; }
            });
        } else {
          await this.productOptionService
            .updateProductOption(updateReq)
            .toPromise()
            .catch(async (e) => {
              const code = e?.error?.exception?.code || e?.error?.code || e?.status;
              const shouldAttach = code === 404 || code === '404' || code === 422 || code === '23503' || code === 'PGRST116';
              if (shouldAttach) {
                await this.productOptionService.attachOptionToProduct(attachReq).toPromise();
              } else {
                throw e;
              }
            });
        }
      }

      await this.getProductOptions();
      tab.show();
    } finally {
      this._savingOptionsInFlight = false;
    }
  }

  updateCharLength(event: Event): void {
    const el = event.target as HTMLInputElement;
    if (!el) { return; }
    el.style.setProperty('--chars', String(el.value ?? '').length.toString());
  }

  private async loadBrands(): Promise<void> {
   this._brands.data.push({
    uuid: this.dashboardLables(this.getPageName()).custom,
    name: this.dashboardLables(this.getPageName()).custom
   });
  }

  private isThereUnsavedVariation(): boolean {
    const variation = this.VARIATIONS_DATA.find(v => !v.uuid);
    return !!(variation);
  }

  async loadData(): Promise<void> {
    await this.onDirectNavigation();

    const hasVatNumber = this.loggedPartner?.data?.organisations?.[0]?.vat_number;
    const vatCtrl = this.productInfo.get('VAT');

    if (hasVatNumber && vatCtrl && !vatCtrl.dirty) {
      vatCtrl.setValue('20', { emitEvent: false });
    }
  }

  async getStores(): Promise<void> {
    await this.onDirectNavigation();
    await this.checkForAddedStores();
    this._storeTabsComponent.setStores(this.stores);
    if (this.showMissingStoreAlert()) {
      this.toastrService.warning('You will not be able to add product without stores', 'Adding a product', { timeOut: 9500 });
    }
  }

  ngOnInit(): void {
    this.getUrlParams().subscribe((params) => {
      const productId = params?.params?.id;
      if (productId) {
        this.newCreatedProduct = {
          data: {
            uuid: productId
          }
        };
      }
    });

    const wCtrl  = this.ship.get('weight');
    const subCtrl = this.productInfo.get('subcategory');

    combineLatest([
      wCtrl.valueChanges.pipe(startWith(wCtrl.value)),
      subCtrl.valueChanges.pipe(startWith(subCtrl.value))
    ]).pipe(
      map(([w, sub]) => {
        const nextType = this.pickCourierType(w, sub);
        const isTyres  = this.subcategoryNameByUuid(sub).toLowerCase() === 'гуми';
        return { nextType, isTyres };
      }),
      distinctUntilChanged((a, b) => a.nextType === b.nextType && a.isTyres === b.isTyres)
    ).subscribe(({ nextType, isTyres }) => {
      this.isTyresSub = isTyres;

      if (this.ship.get('courierType').value !== nextType) {
        this.ship.get('courierType').setValue(nextType, { emitEvent: false });
      }

      this.updateExtrasLock();
    });

    const ctCtrl = this.ship.get('courierType');
    ctCtrl.valueChanges.pipe(startWith(ctCtrl.value)).subscribe(() => {
      this.updateExtrasLock();
    });
  }

  ngAfterViewInit(): void {
    this.base64Files = this._imageUploadComponent.base64Files;
    this._imagesPerProduct = this._imageUploadComponent.imageCollectionPerProduct;
    this.loadTooltips();
  }

  getColor(color): string {
    return this.colors.find(colorEl => colorEl.name === color).color;
  }

  applyParentStyle(element, color): void {
    const colorHex = this.colors.find(colorEl => colorEl.name === color).color;
    if (colorHex) {
      element._elementRef.nativeElement.style = 'border: 1px solid ' + colorHex + ' !important; border-radius: 5px !important';
    }
  }

  getCourrierTypes(typetoGet: string): any {
    return PackagingCorurierTypes.options[this._language].filter(type => type.name === typetoGet)[0];
  }

  toggleCourrierType($event, typetoChange: string): void {
    if (!$event.target.checked) {
      $event.target.checked = true;
      return;
    }
    this.ship.get('courierType').setValue(PackagingCorurierTypes.options[this._language].filter(
      type => type.name === typetoChange)[0].value
    );
  }

  isActiveAll(): boolean { return this.variationType === 'all'; }
  isActive(v: any): boolean {
    const f = String(v?.field_name || '').toLowerCase();
    return (this.variationType === 'size' && f === 'size') ||
      (this.variationType === 'color' && f === 'color');
  }

  private queueLoadVariations(next: 'all'|'size'|'color'): void {
    Promise.resolve().then(() => {
      this.loadVariations(next);
      this.cdr.detectChanges();
    });
  }

  loadVariations(key: 'all' | 'size' | 'color'): void {
    if (!this._variations?.data?.length) { return; }
    this.variationType = key;

    this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();

    if (key === 'all') {
      this._variations.data.forEach(v => {
        this.displayedColumnsForVariations.splice(1, 0, v.display_name);
      });
    } else {
      const v = this._variations.data.find(x => String(x.field_name).toLowerCase() === key);
      const label = v ? v.display_name : (key === 'size' ? 'Размер' : 'Цвят');
      this.displayedColumnsForVariations.splice(1, 0, label);
    }

    this.displayedColumnsForVariations = [...this.displayedColumnsForVariations];
  }

  onlyPositiveNumber(formGroup): void {
    let value = formGroup.value;
    if (value < 0) {
      value = 0;
    }
    formGroup.setValue(value.toString().replace(/\D/i, ''));
  }

  addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.tags.push(value);
    }

    event.input!.value = '';
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  getStoreByName(name: string): Store {
    let matchedStore: Store;
    this.stores.forEach((store) => {
      if (store.name === name) {
        matchedStore = store;
      }
    });
    return matchedStore;
  }

  attachOnPriceEvent(formControl: AbstractControl, id: number, callback: (id, prev, next, scope) => void): void {
    formControl.valueChanges
      .pipe(
        tap(() => this.btnPricesIsDisabled = true),
        debounceTime(1500),
        startWith(null),
        pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        callback(id, prev, next, this);
        this.btnPricesIsDisabled = false;
      });
  }

  attachChangeEventToMultplePricings(id: number): void {
    this.attachOnPriceEvent(this.pricing.get('unitsFrom' + id), id, this.onPriceFromAmountChange);
    this.attachOnPriceEvent(this.pricing.get('unitsTo' + id), id, this.onPriceToAmountChange);
    this.attachOnPriceEvent(this.pricing.get('pricing' + id), id, this.onPriceChange);
  }

onPriceFromAmountChange(id, previousValue, nextValue, scope) {
    if(!nextValue) {
      return;
    }
    if (scope.pricing.get('unitsTo' + id)) {
      const toValue = parseInt(scope.pricing.get('unitsTo' + id).value);
      if (toValue <= nextValue) {
        scope.pricing.get('unitsFrom' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.from.max[scope._language])
      }
    }
    if (nextValue < environment.initialNumberOfPriceRanges) {
      scope.pricing.get('unitsFrom' + id).patchValue(previousValue);
      scope.toastrService.error(Errors.pricing.from.min[scope._language]);
    }
    if (scope.pricing.get('unitsFrom' + (id-1))) {
      const prvoiousFromValue = parseInt(scope.pricing.get('unitsFrom' + (id-1)).value);
      if (prvoiousFromValue > nextValue) {
        scope.pricing.get('unitsFrom' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.from.biggerThen[scope._language])
      }
    }
    if (scope.pricing.get('unitsTo' + (id-1))) {
      const prvoiousToValue = parseInt(scope.pricing.get('unitsTo' + (id-1)).value);
      if (prvoiousToValue >= nextValue) {
        scope.pricing.get('unitsFrom' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.from.smallerThenTo[scope._language])
      }
    }
    if (scope.pricing.get('unitsFrom' + (id+1))) {
      const nextFromValue = parseInt(scope.pricing.get('unitsFrom' + (id+1)).value);
      if (nextFromValue <= nextValue) {
        scope.pricing.get('unitsFrom' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.from.smallerThen[scope._language])
      }
    }
  }

  onPriceToAmountChange(id, previousValue, nextValue, scope) {
    if(!nextValue) {
      return;
    }
    if (scope.pricing.get('unitsFrom' + id)) {
      const fromValue = parseInt(scope.pricing.get('unitsFrom' + id).value);
      if (fromValue >= nextValue) {
        scope.pricing.get('unitsTo' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.to.biggerThen[scope._language])
      }
    }
  }

  onInputChangeMakeOnlyPositive(formControl: AbstractControl): void {
    const changedValue = formControl.value;
    if (changedValue < 0) {
      formControl.setValue('');
      return;
    }
    formControl.setValue(this.convertNumberWithSuffix(changedValue));
  }

  private subcategoryNameByUuid = (uuid: string): string => {
    const m = (this.subCategories || []).find(sc => sc.uuid === uuid);
    return (m?.name || '').trim();
  }

  private pickCourierType(weight: number, subUuid: string): number {

    if (this.subcategoryNameByUuid(subUuid).toLowerCase() === 'гуми') {
      return this.CT_TYRES;
    }

    if (Number(weight) > 50) {
      return this.CT_PALLET;
    }

    return this.CT_STANDART_24;
  }

  private updateExtrasLock(): void {
    const w  = Number(this.ship.get('weight').value);
    const ct = Number(this.ship.get('courierType').value);

    const mustLock =
      w > 50 || ct === this.CT_PALLET || ct === this.CT_TYRES;

    this.extrasLocked = mustLock;

    if (mustLock) {
      this.testExtrasValue = 'none';
      this.ship.get('check_before_pay').setValue(false, { emitEvent: false });
      this.ship.get('test_before_pay').setValue(false,  { emitEvent: false });
    }
  }

  onInputChangeMakeOnlyPositiveAndWholeNumbers(formControl: AbstractControl): void {
    const changedValue = formControl.value;
    if (changedValue < 0) {
      formControl.setValue('');
      return;
    }
    else if (!Number.isInteger(changedValue)) {
      formControl.setValue('');
      return;
    }
    formControl.setValue(changedValue);
  }

  convertNumberWithSuffix(num: number, toSuffix = 2): string {
    return Convertor.convertNumbers.addToFixedSuffix(num, toSuffix);
  }

  onPriceChange(id: number, previousValue, nextValue, scope): void {
    if (!nextValue) {
      return;
    }
    if (scope.pricing.get('pricing' + (id - 1))) {
      const previousPricing = parseFloat(scope.pricing.get('pricing' + (id - 1)).value);
      if (previousPricing < nextValue) {
        scope.pricing.get('pricing' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.price.smallerThen[scope._language]);
      }
    }
    if (scope.pricing.get('pricing' + (id + 1))) {
      const nextPricing = parseFloat(scope.pricing.get('pricing' + (id + 1)).value);
      if (nextPricing > nextValue) {
        scope.pricing.get('pricing' + id).patchValue(previousValue);
        scope.toastrService.error(Errors.pricing.price.biggerThen[scope._language]);
      }
    }
  }

  deleteVariation(variationToDelete): void {
    this.skuService.deleteSku(variationToDelete.uuid).subscribe(() => {
      this.VARIATIONS_DATA = this.VARIATIONS_DATA.filter(variation => {
        if (variation.uuid && variation.uuid === variationToDelete.uuid) {
          return false;
        }
        return true;
      });
      this.variationsDataSource = new MatTableDataSource(this.VARIATIONS_DATA);
      this.toastrService.success(Successes.variationCreation[this._language]);
    });
  }

  selectColor(color: string): void {
    this._color = color;
  }

  openModal(modal, event): void {
    event.preventDefault();
    this.modalService.open(modal, { centered: true } );

  }

  private keepField(): 'size' | 'color' | 'all' {
    return this.variationType;
  }

  private removeField(): 'size' | 'color' | null {
    const k = this.keepField();
    if (k === 'all') { return null; }
    return k === 'size' ? 'color' : 'size';
  }

  async updateVariation(updatedVariation): Promise<void> {

    for (const key in updatedVariation) {
      if (updatedVariation[key] === '' || updatedVariation[key] === null || updatedVariation[key] === undefined) {
        this.toastrService.error('Не са попълнени всички полета за вариациата!');
        return;
      }
    }

    if (!this.validateRequiredPerMode(updatedVariation)) { return; }
    if (!this.validateVariationAgainstMode(updatedVariation)) { return; }

    const updatePromises: Promise<any>[] = [];
    const attachModel: AttachSkuOptionRequestModel = {
      sku_uuid: updatedVariation.uuid,
      options: []
    };

    const currentSKU = this._productSkus?.data?.find(sku => sku.uuid === updatedVariation.uuid);

    const nextSku = String(updatedVariation.sku).trim();
    const nextQty = Number(updatedVariation.quantity);

    const shouldUpdateSku =
      !!currentSKU &&
      (String(currentSKU.sku).trim() !== nextSku ||
        Number(currentSKU.available_quantity) !== nextQty);

    if (shouldUpdateSku) {
      await this.skuService.updateSku(updatedVariation.uuid, nextSku, nextQty).toPromise();
    }

    this._variations.data.forEach(variation => {
      const picked = updatedVariation[variation.display_name];
      if (picked === '' || picked === null || picked === undefined) { return; }

      const valueToSend =
        (variation.field_name === 'color' && Array.isArray(picked)) ? picked[0] : picked;

      const currentSkuOption = currentSKU?.options?.find(o => o.option.uuid === variation.uuid);

      if (currentSkuOption) {
        if (String(currentSkuOption.value) !== String(valueToSend)) {
          const updateSkuOption: UpdateSkuOptionRequestModel = { value: valueToSend };
          updatePromises.push(
            this.skuOptionService.updateSkuOption(updateSkuOption, currentSkuOption.uuid).toPromise()
          );
        }
      } else {
        attachModel.options.push({ uuid: variation.uuid, value: valueToSend });
      }
    });

    if (attachModel.options.length) {
      updatePromises.push(this.skuOptionService.attachOptionToSku(attachModel).toPromise());
    }

    await Promise.all(updatePromises);

    updatedVariation.changed = false;
    this.toastrService.success(Successes.variationCreation[this._language]);
  }


  private validateVariationAgainstMode(v: any): boolean {
    const k = this.keepField();
    if (k === 'all') { return true; }

    const sizeDisplay  = 'Размер';
    const colorDisplay = 'Цвят';

    const hasSize  = !!v[sizeDisplay];
    const hasColor = !!v[colorDisplay];

    return true;
  }

  private hasUnsavedNewRows(): boolean {

    return (this.VARIATIONS_DATA || []).some(v => !v.uuid);
  }

  private hasEditedRows(): boolean {
    return (this.VARIATIONS_DATA || []).some(v => !!v.uuid && !!v.changed);
  }

  private hasMissingRequiredFields(): { hit: boolean; msg?: string } {
    for (const [idx, v] of (this.VARIATIONS_DATA || []).entries()) {
      const miss = this.missingRequiredForRow(v);
      if (miss.length) {
        const rowNo = idx + 1;
        return {
          hit: true,
          msg: `Ред ${rowNo}: задължително поле${miss.length > 1 ? 'та' : ''} ${miss.join(' и ')}.`
        };
      }
    }
    return { hit: false };
  }

  private validateVariationsBeforeContinue(): boolean {
    if (!this._userSelectedWhetherToShowVariations) { return true; }

    if (this.hasUnsavedNewRows()) {
      this.toastrService.warning('Имате незапазени вариации (нов ред без запис). Запазете ги преди да продължите.');
      return false;
    }

    if (this.hasEditedRows()) {
      this.toastrService.warning('Имате редактирани вариации, които не са запазени. Моля, запазете промените.');
      return false;
    }

    const miss = this.hasMissingRequiredFields();
    if (miss.hit) {
      this.toastrService.error(miss.msg);
      return false;
    }

    return true;
  }

  private validateRequiredPerMode(row: any): boolean {
    const miss = this.missingRequiredForRow(row);
    if (miss.length) {
      this.toastrService.error(`Попълни ${miss.join(' и ')} преди запазване.`);
      return false;
    }
    return true;
  }

  async saveVariation(newVariation): Promise<void> {
    for (const key in newVariation) {
      if (newVariation[key] === '' || newVariation[key] === null || newVariation[key] === undefined) {
        this.toastrService.error('Не са попълнени всички полета за вариациата!');
        return;
      }
    }

    if (!this.validateRequiredPerMode(newVariation)) { return; }
    if (!this.validateVariationAgainstMode(newVariation)) { return; }

    if (!this.validateVariationAgainstMode(newVariation)) { return; }

    const newSkuReq: CreateSkuRequestModel = {
      product_uuid: this._newCreatedProduct.data.uuid,
      sku: newVariation.sku,
      quantity: newVariation.quantity
    };
    const createdSku = await this.skuService.createSku(newSkuReq).toPromise();
    newVariation.uuid = createdSku.data.uuid;

    const attachModel: AttachSkuOptionRequestModel = {
      sku_uuid: createdSku.data.uuid,
      options: []
    };

    this._variations.data.forEach(variation => {
      const picked = newVariation[variation.display_name];
      if (picked === '' || picked === null || picked === undefined) { return; }

      const valueToSend =
        variation.field_name === 'color' && Array.isArray(picked) ? picked[0] : picked;

      attachModel.options.push({ uuid: variation.uuid, value: valueToSend });
    });

    await this.skuOptionService.attachOptionToSku(attachModel).toPromise();
    newVariation.changed = false;
    this.toastrService.success(Successes.variationCreation[this._language]);
    this.prepareVariations();
  }

  openImageVariationUpload(element): void {
    if (!element.uuid) {
      this.toastrService.info(INFO_STATUSES.saveSKUBeforrImageUpload[this._language]);
      return;
    }

    const dialogRef = this.dialogService.open(VariationimagesComponent, {
      width: '100%',
      panelClass: 'variation-images-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.prepareVariations();
    });

    dialogRef.componentInstance.setVariation(element.uuid);
    dialogRef.componentInstance.setDialogRef(dialogRef);

  }

  createNewVariation(): void {
    this.VARIATIONS_DATA = [...this.VARIATIONS_DATA, {
      sku: '',
      quantity: null
    }];
    this.variationsDataSource = new MatTableDataSource(this.VARIATIONS_DATA);
    console.log('createNewVariation-----> VARIATIONS_DATA:', this.VARIATIONS_DATA);
  }

  createNewTableRow(): void {
    const tableRowObject: TableVariation = {
      file: null,
      id: this.ELEMENT_DATA.length,
      size: 'YxY',
      SKU: '',
      name: '',
      quantity: null,
      color: ''
    } as any;
    this.ELEMENT_DATA = [...this.ELEMENT_DATA, tableRowObject];
    this.variationDataSource = new MatTableDataSource(this.ELEMENT_DATA);
  }

  removeVariation(id): void {
    if (this.ELEMENT_DATA.length === 1) {
      return;
    }
    this.ELEMENT_DATA = this.ELEMENT_DATA.filter(element => element.id !== id);
    this.variationDataSource.data = this.variationDataSource.data.filter(element => element.id !== id);
  }

  openImageSelection(id): void {
    const self = this;

    const dialogRef = this.dialogService.open(ImageselectionComponent, {
      width: '100%',
      data: self.base64Files
    });

    dialogRef.afterClosed().subscribe(result => {
      self.variationDataSource.data.find(element => element.id === id).file = result;
    });
  }

  increaseRange(): void {
    const id = this.priceRangeCount;
    let currentMaxTo = this.pricing.get('unitsTo' + (id - 1))?.value || 4;
    this._priceRangeCount++;
    if (this.priceRangeCount > 5 && currentMaxTo === 4) {
      currentMaxTo = '';
    }
    this.pricing.addControl(
      'unitsFrom' + id, new FormControl((currentMaxTo) ? currentMaxTo + 1 : '',
        [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]));
    this.pricing.addControl('unitsTo' + id, new FormControl(
    '', [Validators.required, Validators.pattern(ValidationConfig.regexes.number)])
    );
    this.pricing.addControl(
      'pricing' + id, new FormControl('',
        [Validators.required, Validators.pattern(ValidationConfig.regexes.number), Validators.min(0.01)]));
    this.attachChangeEventToMultplePricings(id);
  }

  decreaseRange(): void {
    if (this._priceRangeCount === environment.initialNumberOfPriceRanges) {
      return;
    }
    this._priceRangeCount--;
    const id = this.priceRangeCount;
    this.pricing.removeControl('unitsFrom' + id);
    this.pricing.removeControl('unitsTo' + id);
    this.pricing.removeControl('pricing' + id);
  }

  executePromisesOnCategoryChange(id): Promise<void> {
    if (!id) {
      this._subCategories = {data: []};
      return;
    }
    return new Promise<void>((resolve, reject) => {
      this.categoryService.getSubcategories(id).subscribe(
        subCategories => {
          subCategories.data.push(
            subCategories.data.splice(subCategories.data.indexOf(subCategories.data.find(sc => sc.name === 'Други')), 1)[0]
          );
          this._subCategories = subCategories;
          const subcategory = this._currentProduct?.data?.category?.uuid || this.subCategories[0].uuid;
          // this.productInfo.get('subcategory').setValue(this.subCategories[0].uuid);
          this.loadFullOptions(subcategory);
          this.brandsService.getBrands(subcategory).subscribe(brands => {
            this._brands = brands;
            this._brands.data.push({
              uuid: this.dashboardLables(this.getPageName()).custom,
              name: this.dashboardLables(this.getPageName()).custom
            });
            // this.productInfo.get('brand').setValue(this._brands.data[0].uuid);
            resolve();
          });
        }
      );
    });
  }

  subCategoryChange(event): void {
    // this.getAllAttributesForCategory(event.target.value).then(
    //   attributes => {
    //     this._categoryAttributes = attributes;
    //     this.addAttrName();
    //     this.addAttributesFormControl();
    //   }
    // )

    if (!event.target.value) {
      this._brands = {data: []};
      return;
    }
    const subCategoryUUID = event.target.value;
    this.loadFullOptions(subCategoryUUID);
    this.brandsService.getBrands(subCategoryUUID).subscribe(brands => {
      this._brands = brands;
      this.loadBrands();
    });
    this._subSubCategories = this._subCategories.data.find(subCategory => subCategory.uuid === event.target.value).sub_categories;

  }

  subSubCategoryChange(event): void {
    if (!event.target.value) {
      this._brands = {data: []};
      return;
    }
    const subSubCategoryUUID = event.target.value;
    this.loadFullOptions(subSubCategoryUUID);
    this.brandsService.getBrands(subSubCategoryUUID).subscribe(brands => {
      this._brands = brands;
      this.loadBrands();
    });
  }

  getCustomBrandTag(): string {
    return this.dashboardLables(this.getPageName()).custom;
  }

  changeBrand(event): void {
    this.toggleCustomBrand(event.target.value);
  }

  toggleCustomBrand(currentBrandId: number): void {
    if (currentBrandId === this.customBrandId) {
      document.getElementById('brand').style.width = '40%';
    }
    else {
      document.getElementById('brand').style.width = '100%';
    }
  }

  addAttrName(): void {
    this.attributes.map(
      attribute => {
        attribute.name = Convertor.convertAttributeName.convertFromAPI(attribute.attributeCode);
      });
  }

  private addAttributesFormControl(): void {
    const alwaysKeep = new Set<string>(['quantity', 'description', 'tags', 'gender']);
    const shouldExist = new Set<string>([
      ...Array.from(alwaysKeep),
      ...this.options.map(o => o.display_name.replace('.', ''))
    ]);

    Object.keys(this.specs.controls).forEach(name => {
      if (!shouldExist.has(name)) { this.specs.removeControl(name); }
    });

    for (const opt of this.options) {
      const name = opt.display_name.replace('.', '');
      const existing = this.specs.get(name);

      const validators = [];
      let initial: any = null;

      const isSelect = !opt.can_accept_free_form_values || (opt.values?.length ?? 0) > 0;
      const isBoolean = opt.type?.label === 'boolean';
      const isNumberFreeForm = !isSelect && !isBoolean && opt.type?.label === 'number';
      const isStringFreeForm = !isSelect && !isBoolean && opt.type?.label === 'string';


      if (isBoolean) {
        validators.push(this.requiredBoolean);
        initial = null;
      } else if (isSelect) {
        validators.push(Validators.required);
        initial = null;
      } else if (isNumberFreeForm) {
        validators.push(Validators.required, Validators.pattern(ValidationConfig.regexes.number));
        initial = '';
      } else if (isStringFreeForm) {
        initial = '';
      }

      if (existing) {
        existing.setValidators(validators);
        if (!existing.dirty) { existing.setValue(initial, { emitEvent: false }); }
        existing.updateValueAndValidity({ emitEvent: false });
      } else {
        this.specs.addControl(name, new FormControl(initial, validators));
      }
    }
  }

  hasInstanceAttribute(): boolean {
    return this._hasInstanceAttribute;
  }

  categoryChange(event): void {
    this.executePromisesOnCategoryChange(event.target.value);
  }

  errorMessage(tabId: any): string {
    return this._errorMsgs[tabId];
  }

  validateTabBeforeMoving(tabId): boolean {
    let fieldName = '';
    fieldName = ValidationHelper.formGroup.validate(this._tabidToFormgroup[tabId], this.dashboardLables(this.pageName));
    if (fieldName === this.dashboardLables(this.pageName).stores && this.ship.controls.pickUp.value !== 'true') {
      fieldName = '';
    }
    if (fieldName !== '') {
      this.error = true;
      this._errorMsgs[tabId] = fieldName + this.dashboardLables(this.pageName).invalidField;
      return false;
    }
    return true;
  }

  userVariationOptionSelect(value): void {
      this._userSelectedWhetherToShowVariations = value;
      console.log('userVariationOptionSelect-----> _userSelectedWhetherToShowVariations:', this._userSelectedWhetherToShowVariations);
  }

  markVariationChanged(row: any): void {
    if (!row) { return; }
    row.changed = true;
  }

  onVarSelectChange(row: any, field: 'Цвят' | 'Размер', value: any): void {
    row[field] = value;
    this.markVariationChanged(row);
  }

  onSkuInput(row: any, value: string): void {
    row.sku = value;
    this.markVariationChanged(row);
  }

  onQtyInput(row: any, value: number): void {
    row.quantity = value;
    this.markVariationChanged(row);
  }

  private requiredFieldsForMode(): Array<'Размер'|'Цвят'> {
    if (this.variationType === 'size')  { return ['Размер']; }
    if (this.variationType === 'color') { return ['Цвят'];   }
    return ['Размер', 'Цвят'];
  }

  private missingRequiredForRow(row: any): string[] {
    const need = this.requiredFieldsForMode();
    const missing: string[] = [];
    for (const f of need) {
      const v = row?.[f];
      const empty =
        v === null || v === undefined || v === '' ||
        (Array.isArray(v) && v.length === 0);
      if (empty) { missing.push(f); }
    }
    return missing;
  }

  private fieldByDisplayName(name: string): 'size' | 'color' | '' {
    const n = String(name || '').trim();
    const hit = (this._variations?.data || [])
      .find(v => String(v.display_name).trim() === n);
    if (hit) { return String(hit.field_name).toLowerCase() as any; }

    if (n === 'Размер') { return 'size'; }
    if (n === 'Цвят') {   return 'color'; }
    return '';
  }

  private async detachRemovedFieldOptions(remove: 'size' | 'color'): Promise<void> {
    if (this._detachInFlight) { return; }
    this._detachInFlight = true;

    try {
      const uuids = new Set<string>();

      for (const sku of (this._productSkus?.data ?? [])) {
        for (const opt of (sku.options ?? [])) {
          const optionObj: any = (opt as any)?.option ?? {};
          const field   = String(optionObj.field_name ?? '').toLowerCase();
          const label   = String(optionObj.display_name ?? '').trim();

          const matchesByLabel =
            (remove === 'size'  && label === 'Размер') ||
            (remove === 'color' && label === 'Цвят');

          const shouldRemove = field ? (field === remove) : matchesByLabel;
          if (!shouldRemove) { continue; }

          const uuid = (opt as any)?.uuid as string | undefined;
          if (typeof uuid === 'string' && uuid.length > 0) {
            uuids.add(uuid);
          }
        }
      }

      if (uuids.size === 0) { return; }
      console.log('uuids --->',  uuids);
      await Promise.all(
        Array.from(uuids).map(u =>
          this.skuOptionService
            .deleteSkuOption({ sku_option_uuid: u })
            .toPromise()
            .catch(() => {})
        )
      );
    } finally {
      this._detachInFlight = false;
    }
  }

  private async applyVariationStructure(): Promise<void> {
    const keep   = this.keepField();
    const remove = this.removeField();


    if (keep === 'all') {
      this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();
      (this._variations?.data ?? []).forEach(v => {
        this.displayedColumnsForVariations.splice(1, 0, v.display_name);
      });
      this.displayedColumnsForVariations = [...this.displayedColumnsForVariations];
      this.cdr.detectChanges();
      return;
    }

    if (!remove || !(this._productSkus?.data?.length)) {
      this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();
      const keepLabel = keep === 'size' ? 'Размер' : 'Цвят';
      this.displayedColumnsForVariations.splice(1, 0, keepLabel);
      return;
    }

    await this.detachRemovedFieldOptions(remove);

    this._variations.data = (this._variations?.data ?? []).filter(
      (v: any) => String(v.field_name).toLowerCase() === keep
    );


    this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();
    const keptVar  = (this._variations?.data ?? [])[0];
    const keptName = keptVar ? keptVar.display_name : (keep === 'size' ? 'Размер' : 'Цвят');
    this.displayedColumnsForVariations.splice(1, 0, keptName);

    this.prepareVariations();
    this.displayedColumnsForVariations = [...this.displayedColumnsForVariations];
    this.cdr.detectChanges();
  }

  async  nextTab(tabId, currentTab = null): Promise<void> {
    const step = (this.variations.length) ? 14.2 : 16.6;
    if (currentTab === 'specs') {
      const shouldCreateVariations = this.createVariations();
      if (shouldCreateVariations) {
        shouldCreateVariations.then((variations) => {
          this.ELEMENT_DATA.forEach(tableVariation => {
            const newVariation = variations.find(variation => variation.sku === tableVariation.SKU);
            tableVariation.id = newVariation.id;
            this.variationService.updateImageVariations(tableVariation);
          });
        });
      }
    }

    this.error = false;
    Object.keys(this._errorMsgs).forEach(key => {
      this._errorMsgs[key] = '';
    });
    const tabEl = document.querySelector('a[href="#' + tabId + '"]');
    let tab = new bootstrap.Tab(tabEl);
    switch (currentTab) {
      case 'info': {
        if (this.productInfo.invalid) {
          this.productInfo.markAllAsTouched();
          return;
        }
        this.saveProduct(tab);
        if (this.navValue < 3 * step) {
          this.navValue = 3 * step;
        }
        this.completedTabs.info.passed = true;
        this.completedTabs.specs.completed = true;
        this.completedTabs.specs.passed = false;

        break;
      }
      case 'specs': {
        this.specs.markAllAsTouched();
        if (!this._imageUploadComponent.images.length) {
          this.toastrService.warning('Качете снимки на продукта');
          return;
        }
        if (!this.specs.valid) {
          return;
        }
        if (this.variations.length) {
          const tabElement = document.querySelector('a[href="#variations"]');
          tab = new bootstrap.Tab(tabElement);
          this.saveOptions(tab);
          this.completedTabs.specs.passed = true;
          this.completedTabs.variations.completed = true;
          this.completedTabs.variations.passed = false;
        }
        else {
          this.saveOptions(tab);
          this.completedTabs.specs.passed = true;
          this.completedTabs.price.completed = true;
          this.completedTabs.price.passed = false;
        }
        if (this.navValue < 4 * step) {
          this.navValue = 4 * step;
        }
        this.completedTabs.specs.completed = true;
        break;
      }
      case 'variations': {
        if (this._userSelectedWhetherToShowVariations && this.isThereUnsavedVariation()) {
          this.toastrService.warning('Имате незапазени вариации !');
          return;
        }
        if (!this.validateVariationsBeforeContinue()) { return; }
        await this.applyVariationStructure();

        if (this._userSelectedWhetherToShowVariations) {
          await this.updateBaseSkuQuantity(0);
        } else {
          this.deleteAllVariations();
        }

        if (this.navValue < 5 * step) {
          this.navValue = 5 * step;
        }
        this.completedTabs.variations.passed = true;
        this.completedTabs.variations.completed = true;
        this.completedTabs.price.completed = true;
        this.completedTabs.price.passed = false;

        tab.show();
        break;
      }
      case 'price': {
        if (this.pricing.invalid) {
          return;
        }
        Promise.all(this.deleteCurrentPricings()).then(() => {
          this.savePricing(tab, () => {
            if (this.variations.length) {
              if (this.navValue < 6 * step) {
                this.navValue = 6 * step;
              }
            }
            else {
              if (this.navValue < 5 * step) {
                this.navValue = 5 * step;
              }
            }
            this.completedTabs.price.passed = true;
            this.completedTabs.delivery.completed = true;
            this.completedTabs.price.completed = true;
            this.completedTabs.delivery.passed = false;
          });
        });
        break;
      }
      case 'ship' : {
        this.ship.markAllAsTouched();
        if (!this.ship.valid || !this.validateBaseQuantityForDelivery()) {
          return;
        }

        await this.updateBaseSkuQuantity(
          this._userSelectedWhetherToShowVariations
            ? 0
            : Number(this.productInfo.get('quantity').value)
        );

        this.saveShippingAndPackaging();
        if (this.variations.length) {
          if (this.navValue < 7 * step) {
            this.navValue = 7 * step;
          }
        }
        else {
          if (this.navValue < 6 * step) {
            this.navValue = 6 * step;
          }
        }
        this.completedTabs.delivery.passed = true;
        this.completedTabs.delivery.completed = true;
        break;
      }
      default: {
        tab.show();
        break;
      }
    }
  }

  backVariation(): void {
    if (this.variationSlide === this.variationSlides[1]) {
      this.variationSlide = this.variationSlides[0];
    }
    else {
      const tabEl = document.querySelector('a[href="#specs"]');
      const tab = new bootstrap.Tab(tabEl);
      tab.show();
    }
  }

  private loadCurrentProduct(productId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.productService.getProduct(productId).subscribe(productInfo => {
        this._currentProduct = productInfo;
        this.productInfo.get('name').setValue(productInfo.data.name);
        if (productInfo.data.manufacturer?.name) {
          this.productInfo.get('manufacturer').setValue(productInfo.data.manufacturer.name);
        }
        else {
          this.productInfo.get('manufacturer').reset();
        }
        this.productInfo.get('condition').setValue(productInfo.data.product_condition);
        this.productInfo.get('barcode').setValue(productInfo.data.ean);
        this.productInfo.get('SKU').setValue(productInfo.data.skus[0].sku);
        this.productInfo.get('quantity').setValue(productInfo.data.skus[0].available_quantity);
        this.productInfo.get('VAT').setValue(parseInt(productInfo.data.vat_percentage, 10));
        this.productInfo.get('warranty').setValue(productInfo.data.guarantee_in_months);
        this.specs.get('description').setValue(productInfo.data.description);
        resolve();
      });
    });
  }

  private deleteAllVariations(): void {
    this._productSkus.data.forEach(sku => {
      if (sku.options.length) {
        this.skuService.deleteSku(sku.uuid).toPromise();
      }
    });
  }

  saveShippingAndPackaging(): void {
    const createPackagingRequestModel: CreatePackagingRequestModel = {
      uuid: this._currentProduct?.data?.packaging?.uuid,
      product_uuid: this._newCreatedProduct.data.uuid,
      package_type: PackagingOptions.options.bg[0].value,
      delivery_time_in_days: this.ship.get('shippWithin').value,
      dimensions: {
          weight: this.ship.get('weight').value,
          width: 0,
          height: this.ship.get('height').value,
          length: this.ship.get('length').value,
          depth: this.ship.get('depth').value
      },
      courier_services: {
        carrier_uuid: this.loggedPartner.data.carrier.data[0].uuid,
        service_id: this.loggedPartner.data.carrier.data[0].settings.client_id,
        other_options: {
          test_before_pay: this.ship.get('test_before_pay').value,
          check_before_pay: this.ship.get('check_before_pay').value,
          type: this.ship.get('courierType').value,
          fragile: this.ship.get('fragile').value,
        }
      }
    };
    if (this._currentProduct?.data?.packaging?.uuid) {
      this.packagingService.updatePackaging(createPackagingRequestModel).subscribe(() => {
        this.toastrService.success(Successes.productFinalization[this._language]);
        this.goToDashboard();
      });
    }
    else {
      this.packagingService.createPackaging(createPackagingRequestModel).subscribe(() => {
        this.toastrService.success(Successes.productFinalization[this._language]);
        this.goToDashboard();
      });
    }
  }

  private deleteCurrentPricings(): Promise<any>[] {
    const arrayOfPromisses: Promise<any>[] = [];
    this._productPricing.data.forEach(productPricing => {
      if (productPricing.quantity_from > 4) {
        arrayOfPromisses.push(this.pricingsService.deleteProductPricing(productPricing.uuid).toPromise());
      }
    });
    return arrayOfPromisses;
  }

  private async savePricing(tab, callback): Promise<void> {
    if (this.pricing.invalid) {
      return;
    }
    const createBasePricingRequestModel: CreateBasePricingRequestModel = {
      product_uuid: this._newCreatedProduct.data.uuid,
      prices: []
    };
    for (let i = 0; i < 4; i++) {
      createBasePricingRequestModel.prices.push({
        price: Number.parseFloat(this.pricing.get('pricing' + i).value),
        quantity: i + 1
      });
    }
    if (this._productPricing.data.length) {
      await this.pricingsService.patchBasePricing(createBasePricingRequestModel).toPromise();
    }
    else {
      await this.pricingsService.createBasePricing(createBasePricingRequestModel).toPromise();
    }
    const arrayOfPromisses: Promise<any>[] = [];
    for (let i = 4; i < this.priceRangeCount; i++) {
      const createCustomPricingRequestModel: CreatePricingRequestModel = {
        product_uuid: this._newCreatedProduct.data.uuid,
        price_per_piece: Number.parseFloat(this.pricing.get('pricing' + i).value),
        quantity_from: Number.parseFloat(this.pricing.get('unitsFrom' + i).value),
        quantity_to: Number.parseFloat(this.pricing.get('unitsTo' + i).value)
      };
      arrayOfPromisses.push(this.pricingsService.createCustomPricing(createCustomPricingRequestModel).toPromise());
    }
    let promiseIndex = 0;
    for (const promise of arrayOfPromisses) {
      promiseIndex++;
      const timeOut = (interv) => {
        setTimeout(async () => {
                await promise;
                if (interv === arrayOfPromisses.length) {
                  this.loadProductPricing(false);
                  callback();
                  tab.show();
                }
        }, interv * 100);
      };
      timeOut(promiseIndex);
    }

  }

  private preparePricing(initialPricingLoad = true): void {
    if (this._productPricing.data.length === this.priceRangeCount && !initialPricingLoad) {
      return;
    }
    if (this._productPricing.data.length) {
      this._priceRangeCount--;
      const id = this.priceRangeCount;
      this.pricing.removeControl('unitsFrom4');
      this.pricing.removeControl('unitsTo4');
      this.pricing.removeControl('pricing4');
    }
    this._productPricing.data.forEach(productPrice => {
      if (productPrice.quantity_from < 5) {
        this.pricing.get('pricing' + (productPrice.quantity_from - 1)).setValue(Number(productPrice.price_per_piece).toFixed(2));
      }
      else {
        const id = this.priceRangeCount;
        this._priceRangeCount++;
        this.pricing.addControl(
          'unitsFrom' + id, new FormControl(
            productPrice.quantity_from,
            [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]
          )
        );
        this.pricing.addControl(
          'unitsTo' + id, new FormControl(
            productPrice.quantity_to,
            [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]
          )
        );
        this.pricing.addControl(
          'pricing' + id, new FormControl(
            Number(productPrice.price_per_piece).toFixed(2),
            [Validators.required, Validators.pattern(ValidationConfig.regexes.number)]
          )
        );
        this.attachChangeEventToMultplePricings(id);
      }
    });
  }
  trackVariation = (index: number, row: any) => row?.uuid ?? row?.sku ?? index;

  private getField(opt: any): 'size' | 'color' | null {
    const f = String(opt?.option?.field_name || '').toLowerCase();
    if (f === 'size' || f === 'color') { return f as any; }

    const d = String(opt?.option?.display_name || '').trim().toLowerCase();
    if (d === 'размер' || d === 'size') { return 'size'; }
    if (d === 'цвят'   || d === 'color') { return 'color'; }
    return null;
  }

  private prepareVariations(): void {
    this.VARIATIONS_DATA = [];

    this.skuService.getSkus(this._newCreatedProduct.data.uuid).subscribe(skuCollection => {
      let hasSize = false;
      let hasColor = false;

      skuCollection.data.forEach((sku: any) => {
        if (!sku.options.length) { return; }

        this.imageService.getImagesPerProduct('SKU', sku.uuid).subscribe(images => {
          this.imageCollectionPerVariation[sku.uuid] = images;
        });

        const variation: any = {
          sku: sku.sku,
          quantity: sku.available_quantity,
          uuid: sku.uuid
        };

        sku.options.forEach((opt: any) => {
          const field = this.getField(opt);
          const name  = String(opt?.option?.display_name || '').trim();

          if (field === 'size') {  hasSize  = true; }
          if (field === 'color') { hasColor = true; }

          if (field === 'color') {
            const match = (this.vcolors || []).find(c =>
              String(c.uuid) === String(opt.value) || String(c.value) === String(opt.value)
            );
            variation[this.LABELS.color] = match ? [match.uuid, match.value] : opt.value;
          } else if (field === 'size') {
            const match = (this.vsizes || []).find(s =>
              String(s.uuid) === String(opt.value) || String(s.value) === String(opt.value)
            );
            variation[this.LABELS.size] = match ? String(match.uuid) : String(opt.value);
          } else {
            variation[name] = opt.value;
          }
        });

        this.VARIATIONS_DATA = [...this.VARIATIONS_DATA, variation];
      });

      if (!this.VARIATIONS_DATA.length) {
        this.VARIATIONS_DATA = [...this.VARIATIONS_DATA, { sku: '', quantity: null }];
      }

      this.variationsDataSource = new MatTableDataSource(this.VARIATIONS_DATA);
      this._productSkus = skuCollection;
      this._userSelectedWhetherToShowVariations = this._productSkus.data.some(
        sku => (sku.options || []).length > 0
      );

      this.displayedColumnsForVariations = this.defaultColumnsForVariations.slice();

      if (hasSize && hasColor) {
        this.variationType = 'all';
        this.queueLoadVariations('all');
      } else if (hasSize) {
        this.variationType = 'size';
        this.queueLoadVariations('size');
      } else if (hasColor) {
        this.variationType = 'color';
        this.queueLoadVariations('color');
      } else {
        this.variationType = 'all';
        this.queueLoadVariations('all');
      }

      this._variationTypeInitialized = true;
    });
  }

  private loadProductPricing(initialPricingLoad = true): void {
    this.pricingsService.getProductPricing(this._newCreatedProduct.data.uuid).subscribe(pricing => {
      this._productPricing = pricing;
      this.preparePricing(initialPricingLoad);
    });
  }

  private workedWithProductUpdate(tab): void {
    this.loadProductPricing(true);
    this.getProductTags();
    this.prepareVariations();
    this.getProductPackaging();
    // this.toastrService.success(Successes.productCreation[this._language]);
    this._imageUploadComponent.setProduct(this._newCreatedProduct);
    tab.show();
  }

  private async getProductTags(): Promise<void> {
    this._tags = await this.tagsService.getTags(this._newCreatedProduct.data.uuid).toPromise();
    this.tags = this._tags.data.map(tagInfo => tagInfo.slug);
  }

  toggleFragile($event, isFragile: boolean): void {
    if (!$event.target.checked) {
      $event.target.checked = true;
      return;
    }
    this.ship.get('fragile').setValue(isFragile);
  }

  private async getProductPackaging(): Promise<void> {
    if (!this._currentProduct?.data?.packaging) { return; }
    this.ship.get('shippWithin').setValue(this._currentProduct.data.packaging?.delivery_time_in_days);
    this.ship.get('height').setValue(this._currentProduct.data.packaging?.dimensions.height);
    this.ship.get('length').setValue(this._currentProduct.data.packaging?.dimensions.length);
    this.ship.get('depth').setValue(this._currentProduct.data.packaging?.dimensions.depth);
    this.ship.get('weight').setValue(this._currentProduct.data.packaging?.dimensions.weight);
    this.ship.get('fragile').setValue(this._currentProduct.data.packaging?.courier_services.other_options.fragile);
    this.ship.get('check_before_pay').setValue(this._currentProduct.data.packaging?.courier_services.other_options.check_before_pay);
    this.ship.get('test_before_pay').setValue(this._currentProduct.data.packaging?.courier_services.other_options.test_before_pay);
    this.ship.get('courierType').setValue(this._currentProduct.data.packaging?.courier_services.other_options.type);
    if (this._currentProduct.data.packaging?.courier_services.other_options.check_before_pay &&
      this._currentProduct.data.packaging?.courier_services.other_options.test_before_pay) {
        this.testExtrasValue = 'both';
    }
    else if (this._currentProduct.data.packaging?.courier_services.other_options.check_before_pay) {
      this.testExtrasValue = 'check';
    }
    else if (this._currentProduct.data.packaging?.courier_services.other_options.test_before_pay) {
      this.testExtrasValue = 'test';
    }
    else {
      this.testExtrasValue = 'none';
    }
  }

  unitFor = (uuid: string): string | null => this._optionUnits.get(uuid) ?? null;

  private async getProductOptions(): Promise<void> {
    const productUuid = this._newCreatedProduct?.data?.uuid;
    if (!productUuid) { return; }

    try {
      this._productOptions = await this.productOptionService
        .getOptionsForProduct(productUuid)
        .toPromise();
    } catch {
      this._productOptions = { data: [] } as any;
    }

    const items: any[] = Array.isArray(this._productOptions?.data) ? this._productOptions.data : [];

    for (const opt of this.options) {
      const ctrlName = opt.display_name.replace('.', '');
      const ctrl = this.specs.get(ctrlName);
      if (!ctrl) { continue; }

      const current = items.find(p => {
        const candUuid = String(p?.option?.uuid ?? p?.option_uuid ?? p?.uuid ?? '');
        if (candUuid && candUuid === String(opt.uuid)) { return true; }
        const candName = String(p?.display_name ?? p?.name ?? '').trim();
        return !!candName && candName === String(opt.display_name).trim();
      });

      if (!current) { continue; }

      const raw = (current?.value && typeof current.value === 'object' && ('uuid' in current.value || 'value' in current.value))
        ? current.value
        : { value: current?.value };

      // BOOLEAN
      if (opt.type.label === 'boolean') {
        const s = String(raw?.value ?? '').trim().toLowerCase();
        const b = ['1', 'true', 'yes', 'да', 'y', 'on'].includes(s) ? true
          : ['0', 'false', 'no', 'не', 'n', 'off'].includes(s) ? false
            : null;
        ctrl.setValue(b, { emitEvent: false });
        this._optionUnits.delete(opt.uuid);
        continue;
      }

      // SELECT
      const isSelect = !opt.can_accept_free_form_values || (opt.values?.length ?? 0) > 0;
      if (isSelect) {
        const incoming = String(raw?.uuid ?? raw?.value ?? '').trim();
        const match = (opt.values || []).find(v =>
          String(v.uuid) === incoming || String(v.value) === incoming
        );
        const valueToSet = match ? String(match.uuid) : null;
        ctrl.setValue(valueToSet, { emitEvent: false });
        this._optionUnits.delete(opt.uuid);
        continue;
      }

      // FREE-FORM
      if (opt.type.label === 'number') {
        const s = String(raw?.value ?? '').trim();
        const m = s.match(/^(-?\d+(?:[.,]\d+)?)(?:\s*(.*))?$/);
        if (m) {
          const num = Number(m[1].replace(',', '.'));
          if (Number.isFinite(num)) { ctrl.setValue(num, { emitEvent: false }); }
          const unit = (m[2] || '').trim();
          if (unit) { this._optionUnits.set(opt.uuid, unit); } else { this._optionUnits.delete(opt.uuid); }
        }
        continue;
      }

      // FREE-FORM string
      ctrl.setValue(String(raw?.value ?? '').replace(/\s+/g, ' ').trim(), { emitEvent: false });
      this._optionUnits.delete(opt.uuid);
    }
  }

  private getBaseSkuForCurrentProduct(): any {
    const loadedSku = (this._productSkus?.data || []).find(sku => !(sku.options || []).length);
    if (loadedSku) {
      return loadedSku;
    }

    return this._currentProduct?.data?.skus?.[0] || null;
  }

  private validateBaseQuantityForDelivery(): boolean {
    const quantityControl = this.productInfo.get('quantity');

    if (this._userSelectedWhetherToShowVariations) {
      quantityControl.setValidators([
        Validators.required,
        Validators.pattern(ValidationConfig.regexes.numberOnly),
        Validators.min(0)
      ]);
      quantityControl.setValue(0, { emitEvent: false });
    } else {
      quantityControl.setValidators([
        Validators.required,
        Validators.pattern(ValidationConfig.regexes.numberOnly),
        Validators.min(1)
      ]);
    }

    quantityControl.updateValueAndValidity();

    if (quantityControl.invalid) {
      quantityControl.markAsTouched();
      return false;
    }

    return true;
  }

  private async updateBaseSkuQuantity(quantity: number): Promise<void> {
    const baseSku = this.getBaseSkuForCurrentProduct();
    if (!baseSku?.uuid) {
      return;
    }

    const skuCode = this.productInfo.get('SKU').value || baseSku.sku;
    await this.skuService.updateSku(baseSku.uuid, skuCode, Number(quantity)).toPromise();

    if (baseSku.available_quantity !== undefined) {
      baseSku.available_quantity = Number(quantity);
    }
  }

  private saveProduct(tab): void {
    if (this._newCreatedProduct?.data?.uuid) {
      this.updateCurrentProduct().then(updatedProduct => {
        const baseSku = this.getBaseSkuForCurrentProduct();
        const baseQuantity = this._userSelectedWhetherToShowVariations
          ? 0
          : Number(this.productInfo.get('quantity').value || 0);

        this.skuService.updateSku(baseSku.uuid, this.productInfo.get('SKU').value, baseQuantity).subscribe(() => {
          this.loadCurrentProduct(this._newCreatedProduct.data.uuid);
          this.workedWithProductUpdate(tab);
          this.getProductOptions();
        });
      });
    }
    else {
      this.createNewroduct().then(createdProduct => {
        const createSkuModel: CreateSkuRequestModel = {
          product_uuid: createdProduct.data.uuid,
          sku: this.productInfo.get('SKU').value,
          quantity: 0,
        };
        this.skuService.createSku(createSkuModel).subscribe((sku) => {
          this.newCreatedProduct = createdProduct;
          this.workedWithProductUpdate(tab);
          this.getProductOptions();
        });
      });
    }
  }

  selectExtras(event): void {
    const value = event.target.value;
    if (!value) {
      return;
    }

    if (this.extrasLocked) {
      this.testExtrasValue = 'none';
      this.ship.get('check_before_pay').setValue(false);
      this.ship.get('test_before_pay').setValue(false);
      return;
    }

    switch (value) {
      case 'check':
        this.ship.get('check_before_pay').setValue(true);
        this.ship.get('test_before_pay').setValue(false);
        break;
      case 'test':
        this.ship.get('check_before_pay').setValue(false);
        this.ship.get('test_before_pay').setValue(true);
        break;
      case 'both':
        this.ship.get('check_before_pay').setValue(true);
        this.ship.get('test_before_pay').setValue(true);
        break;
      default:
        this.ship.get('check_before_pay').setValue(false);
        this.ship.get('test_before_pay').setValue(false);
        break;
    }

    this.testExtrasValue = value;
  }

  public shouldCreateBrand(): boolean {
    if (this.productInfo.get('brand').value === this.getCustomBrandTag()) {
     return true;
    }
    return false;
  }

  compareColors(o1: any, o2: any): boolean {
    return o1[0] === o2[0] && o1[1] === o2[1];
  }

  handleTabRedirect(event, tabElement, scope): boolean {
    if (tabElement.completed) {
      if (tabElement.tab === '#info') {
        if (scope._newCreatedProduct?.data?.uuid && !scope._currentProduct) {
          scope.router.navigate(['dashboard/products/add/' + scope._newCreatedProduct?.data?.uuid]);
          return false;
        }
      }
      let index = 1;
      let tabIndex = 1;
      document.querySelectorAll('#myTab a').forEach(element => {
        index++;
        if (element.getAttribute('href') === tabElement.tab) {
          tabIndex = index;
        }
      });
      const step = (this.variations.length) ? 14.2 : 16.6;
      this.navValue = tabIndex * step;
      const tabEl = document.querySelector('a[href="' + tabElement.tab + '"]');
      const tab = new bootstrap.Tab(tabEl);
      tab.show();
    }
    event.stopImmediatePropagation();
    event.stopPropagation();
    return false;
  }

  handleCancelRedirect(): void {
    const productUuid = this._newCreatedProduct?.data?.uuid;

    if (!productUuid) {
      this.router.navigate(['dashboard/products']);
      return;
    }

    this.productService.recalculateProductState(productUuid).subscribe({
      next: (success) => {
        this.router.navigate(['dashboard/products']);
        console.log('Recalculate product state success', success);
      },
      error: (err) => {
        console.warn('Recalculate product state failed on exit', err);
        this.router.navigate(['dashboard/products']);
      }
    });
  }

  async updateCurrentProduct(): Promise<CreatedProduct> {
    const customBrand = await this.createBrandIfNeeded();
    this.productInfo.get('brand').setValue((customBrand) ? customBrand.data.uuid : this.productInfo.get('brand').value);
    const updatedProduct: UpdateProductRequestModel = {
      description: this.specs.get('description').value || '',
      category_uuid: this.productInfo.get('subSubCategory').value || this.productInfo.get('subcategory').value,
      brand_uuid: (customBrand) ? customBrand.data.uuid : this.productInfo.get('brand').value,
      ean: this.productInfo.get('barcode').value,
      sku: this.productInfo.get('SKU').value,
      guarantee_in_months: this.productInfo.get('warranty').value,
      vat_percentage: this.productInfo.get('VAT').value,
      name: this.productInfo.get('name').value,
      product_condition: this.productInfo.get('condition').value
    };
    if (this.productInfo.get('manufacturer').dirty) {
      const manufacturer = await this.createManufacturer();
      updatedProduct.manufacturer_uuid = manufacturer.data.uuid;
    }
    return this.productService.updateProduct(updatedProduct, this._newCreatedProduct.data.uuid).toPromise();
  }

  async createBrandIfNeeded(): Promise<NewBrand>{
    let customBrand: NewBrand;
    if (this.shouldCreateBrand()) {
      customBrand = await this.createBrand();
    }
    return customBrand;
  }

  async createManufacturer(): Promise<Manufacturer> {
    if (!this.productInfo.get('manufacturer').value) { return; }
    const newManufacturer: CreateNewManufacturerRequestModel = {
      name: this.productInfo.get('manufacturer').value
    };
    const manufacturer = await this.manufacturerService.createNewManufacturer(newManufacturer).toPromise();
    return manufacturer;
  }

  async createNewroduct(): Promise<CreatedProduct> {
    const customBrand = await this.createBrandIfNeeded();
    const manufacturer = await this.createManufacturer();
    const newProduct: CreateNewProductRequestModel = {
      organisation_uuid: this.loggedPartner.data.organisations[0].uuid,
      category_uuid: this.productInfo.get('subSubCategory').value || this.productInfo.get('subcategory').value,
      brand_uuid: (customBrand) ? customBrand.data.uuid : this.productInfo.get('brand').value,
      ean: this.productInfo.get('barcode').value,
      sku: this.productInfo.get('SKU').value,
      guarantee_in_months: this.productInfo.get('warranty').value,
      vat_percentage: this.productInfo.get('VAT').value,
      name: this.productInfo.get('name').value,
      product_condition: this.productInfo.get('condition').value
    };
    if (manufacturer) {
      newProduct.manufacturer_uuid = manufacturer.data.uuid;
    }
    return this.productService.createNewProduct(newProduct).toPromise();
  }

  private createVariations(): Promise<Variation[]> {
    if (this.hasInstanceAttribute() && this.ELEMENT_DATA.find(element => element.SKU)) {
      return Promise.all(this.variationService.createVariations(this.ELEMENT_DATA, this._createdProduct));
    }
    return null;
  }

  private prepareProductForUpdate(): void {
    this._createdProduct.createdBy = this.loggedUser.firstName + ' ' + this.loggedUser.lastName;
    this._createdProduct.guaranteeDurationInMonths =	this.productInfo.get('warranty').value;
    this._createdProduct.heightValue =	this.ship.get('height').value;
    this._createdProduct.ean =	this.productInfo.get('barcode').value;
    this._createdProduct.lengthValue =	this.ship.get('length').value;
    this._createdProduct.weightValue =	this.ship.get('weight').value;
    this._createdProduct.manufacturer =	this.productInfo.get('manufacturer').value;
    this._createdProduct.name =	this.productInfo.get('name').value;
    this._createdProduct.partnerCode =	this.loggedUser.partner.name;
    this._createdProduct.partnerId =	this.loggedUser.partner.id;
    this._createdProduct.sku =	this.productInfo.get('SKU').value;
    this._createdProduct.vatCategory =	this.productInfo.get('VAT').value;
    this._createdProduct.volumeValue =	this.ship.get('depth').value * this.ship.get('length').value * this.ship.get('height').value;
    this._createdProduct.widthValue =	this.ship.get('depth').value;
    this._createdProduct.category01Id = this.productInfo.get('category').value;
    this._createdProduct.category02Id = this.productInfo.get('subcategory').value;
    this._createdProduct.category03Id = this.productInfo.get('brand').value;
    this._createdProduct.description = this.specs.get('description').value;
    this._createdProduct.type = environment.item;
    this._createdProduct.condition = this.productInfo.get('condition').value;
    this._createdProduct.dlvPickUp = this.ship.get('pickUp').value;
    this._createdProduct.qtyAvailableUnit = (this.specs.get('quantity')) ? (this.specs.get('quantity')).value : undefined;
    this._createdProduct.gender = (this.productInfo.get('gender')) ? (this.productInfo.get('gender')).value : undefined;
    this.addProductAttrToNewProduct();
  }

  private addProductAttrToNewProduct(): void {
    Object.keys(this.specs.controls).forEach(control => {
      if (this.defaultAttr.indexOf(control) < 0) {
        const attrName = control.toLowerCase() + 'Attr';
        this._createdProduct[attrName] = this.specs.get(control).value;
      }
    });
  }

  updateProduct(): Promise<any>{
      this.prepareProductForUpdate();
      return this.itemService.updateItem(this._createdProduct).toPromise();
  }

  upload(currentTab): void {
    if (this.validateTabBeforeMoving(currentTab)) {
      // let shouldCreateVariations = this.createVariations();
      const createProductPromises: Promise<any>[] =
        [
          this.updateProduct(),
        ];
      createProductPromises.concat(this.pricingService.createPricings(this.pricing, this._createdProduct.id, this._priceRangeCount));
      // if (shouldCreateVariations) {
      //  createProductPromises.push(shouldCreateVariations)
      // }
      Promise.all(createProductPromises)
        .then(() => {
          this.toastrService.success(
            Successes.productCreation[this._language]
          );
          this.goToDashboard();
        });
    }
  }
}
